import { Box, styled } from '@mui/material';

export const DashboardVariantV2GiverHeaderContainer = styled(Box)(
  ({ theme }) => ({
    display: 'grid',
    gap: theme.spacing(1.5),
    gridTemplateColumns: '300px 1fr 1fr 300px',
  }),
);
